import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Journey } from "@/components/site/Journey";
import { Charity } from "@/components/site/Charity";
import { Plans } from "@/components/site/Plans";
import { Platforms } from "@/components/site/Platforms";
import { Closing } from "@/components/site/Closing";
import { Footer } from "@/components/site/Footer";
import { SocialProof } from "@/components/site/SocialProof";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.3, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main data-testid="landing-page" className="overflow-x-clip">
      <Hero />
      <Marquee />
      <Journey />
      <Charity />
      <Plans />
      <Platforms />
      <Closing />
      <Footer />
      <SocialProof />
    </main>
  );
}

export default App;
